import PassengerUpdateRequest, {
  PassengerUpdateRequestBody,
} from "./passenger-update.request";

const createBody = (
  request: PassengerUpdateRequest,
): PassengerUpdateRequestBody => {
  return {
    email: request.email,
    firstName: request.firstName,
    lastName: request.lastName,
    mobilePrimary: request.mobilePrimary,
    mobilePrimaryPrefix: request.mobilePrimaryPrefix,
    mobileSecondary: request.mobileSecondary,
    mobileSecondaryPrefix: request.mobileSecondaryPrefix,
    passenger: request.passenger,
  };
};

const passengerUpdateRequestFactory = {
  createBody,
};

export default passengerUpdateRequestFactory;
